__turbopack_context__.v({
  "arrowSvg": "Carousel-module__U6LRfa__arrowSvg",
  "arrowSvgDisabled": "Carousel-module__U6LRfa__arrowSvgDisabled",
  "button": "Carousel-module__U6LRfa__button",
  "buttonDisabled": "Carousel-module__U6LRfa__buttonDisabled",
  "container": "Carousel-module__U6LRfa__container",
  "containerLessItems": "Carousel-module__U6LRfa__containerLessItems",
  "controls": "Carousel-module__U6LRfa__controls",
  "unorderedList": "Carousel-module__U6LRfa__unorderedList",
});
